import React from "react";
import tdahImage from '../../assets/images/servicos/tdah.jpg';

const Tdah = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>TDAH</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">TDAH</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={tdahImage} alt="TDAH" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> TRANSTORNO DE DÉFICIT DE ATENÇÃO E HIPERATIVIDADE (TDAH) </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>Um tema muito popular hoje em dia é o TDAH. Muitas crianças pequenas estão sendo indicadas para avaliação e psicoterapia por apresentarem comportamentos como agitação, falta de concentração e, em boa parte dos casos, as crianças já chegam com o “diagnóstico” de pessoas não qualificadas para isso ou que não estão preparadas para lidarem com questões comuns da infância (infelizmente parte deles trabalham com ela).</p><br />
                                        <p>Antes de pensarmos em um transtorno, precisamos organizar a casa. Ver a rotina dessa criança, o sono, a atenção de qualidade, o brincar, o acesso a telas e vários outros fatores. Somente depois de tudo “limpo” e a permanência dos sintomas que vamos investigar o transtorno. Lembrando que o TDAH também é genético.</p><br />
                                        <p>Para esclarecer, é preciso saber que o TDAH é um transtorno do neurodesenvolvimento e tem por característica um padrão persistente de desatenção e a hiperatividade/impulsividade, o que afetará o comportamento e o aprendizado. Dentro do transtorno, temos 3 subtipos que são:</p><br />
                                        <ul>
                                            <li>Predominantemente desatento - Quando os critério de desatenção são atendidos, mas não os de hiperatividade/impulsividade</li>
                                            <li>predominantemente hiperativo/impulsivo - Quando os critérios de hiperatividade/impulsividade são atendidos, mas não os de desatenção</li>
                                            <li>Apresentação combinada - quando os critérios de desatenção e hiperatividade/impulsividade são atendidos.</li>
                                        </ul><br />
                                        <p>Em relação aos sintomas, pode variar de leve, moderado ou grave e os sintomas precisam ser avaliados dentro do contexto do desenvolvimento da criança para garantir um diagnostico preciso.</p><br />
                                        <p>Alguns sintomas comuns que as crianças apresentarão são dificuldade de concentração, agitação, impulsividade, dificuldade em seguir instruções ou em esperar sua vez (o que pode afetar o desempenho escolar e a socialização - geralmente isso gera conflitos com amigos) Além também de afetar o desempenho escolar da criança.</p><br />
                                        <p><b>Como a psicoterapia pode ajudar?</b></p><br />
                                        <p>A psicoterapia dentro da abordagem cognitivo comportamental (TCC) para o tratamento do TDAH ajudará nas habilidades de autorregulação, na organização e no foco. Também ajudará a criar um ambiente de rotina e consistência (importante demais para conseguir manter um ambiente familiar estável) e também incentivará o autocontrole e melhorará a socialização e o desempenho escolar da criança.</p><br /><br />
                                        <p><i>Jéssica Silvestre Santos<br />
                                                Psicóloga Infantojuvenil<br />
                                                Idealizadora da Clinica CreSer<br />
                                                Mãe de 2 meninas<br />
                                        </i></p><br />
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                        <aside className="widget widget_text">
                            <h3 className="widgettitle">Assuntos Relacionados</h3>
                            <p><a href="/transtornos-ansiedade-infantil">Transtornos de ansiedade infantil</a></p><br />
                        </aside>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Tdah;
